import { useQuery } from '@tanstack/react-query';
import useLocaleQueryFilter from '../../utils/useLocaleQueryFilter';
import { ImageType } from './useProducts';

export type MenuItem = {
  id: number;
  parentId: number;
  name: string;
  description: string;
  slug: string;
  imageLocalized: ImageType;
  imageDefault: ImageType;
  children: MenuItem[];
};

export default function useMenu() {
  const { licenseId, localeId } = useLocaleQueryFilter();
  const accessPhysicalProduct = window.config?.ACCESS_PHYSICAL_PRODUCT;
  const accessBonus = window.config?.ACCESS_BONUS;
  return useQuery<MenuItem[], Error>(
    [
      'categories/mainMenu',
      { licenseId, localeId, accessPhysicalProduct, accessBonus },
    ],
    {
      staleTime: 1000,
      enabled: !!licenseId && !!localeId,
    },
  );
}
